(function(algolia) {
  'use strict';
  const insightsClient = window[window.AlgoliaAnalyticsObject];

  const enabled = algolia.config.analytics_enabled;
  if (!enabled || !insightsClient) return;

  // useCookie parameter set up
  const userTokenAdminSetting = algolia.config.usertoken_with_cookies === 'enabled';
  let useCookie = false;

  if(userTokenAdminSetting) {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          console.error("Customer Privacy API Error", error);
        }
        const userCanBeTracked = window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy.userCanBeTracked() : false;
        useCookie = userTokenAdminSetting && userCanBeTracked;
        insightsClient('init', {useCookie, partial: true});
      },
    );
  } else {
    insightsClient('init', {useCookie: useCookie, partial: true});
  }

  // Local storage logic for conversion events
  const localStorageKey = 'algolia_analytics_clicked_objects';

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      // Add the current products data to local storage
      previousClickItems.push(data)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
    } catch (error) {
      console.error(error);
      // No need to do anything in this scenario
    }
  };

  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
  function trackConversion() {

    try {
      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey)
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString)
        previousClickItems.forEach((data) => {
          insightsClient('init', {
            appId: algolia.config.app_id, 
            apiKey: algolia.config.search_api_key,
            useCookie,
            partial: true
          });
          insightsClient('convertedObjectIDsAfterSearch', data)
        })
      }
    } catch (error) {
      console.error(error);
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey)
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  /**
   *Track a conversion event when clicking the 'add to cart' button.
   *Change the query selector to be the correct one for your theme.
   */
  const addToCartBtn = document.querySelector('YOUR_ADD_TO_CART_SELECTOR')
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      trackConversion()
    })
  }
  // add this before event code to all pages where PII data postback is expected and appropriate 
ttq.identify({
	"email": "<hashed_email_address>", // string. The email of the customer if available. It must be hashed with SHA-256 on the client side.
	"phone_number": "<hashed_phone_number>", // string. The phone number of the customer if available. It must be hashed with SHA-256 on the client side.
	"external_id": "<hashed_extenal_id>" // string. Any unique identifier, such as loyalty membership IDs, user IDs, and external cookie IDs.It must be hashed with SHA-256 on the client side.
});

ttq.track('ViewContent', {
	"contents": [
		{
			"content_id": "<content_identifier>", // string. ID of the product. Example: "1077218".
			"content_type": "<content_type>", // string. Either product or product_group.
			"content_name": "<content_name>", // string. The name of the page or product. Example: "shirt".
			"price": "<content_price>" // number. The price of a single item. Example: 25.
		}
	],
	"value": "<content_value>", // number. Value of the order or items sold. Example: 100.
	"currency": "<content_currency>" // string. The 4217 currency code. Example: "USD".
});

ttq.track('AddToCart', {
	"contents": [
		{
			"content_id": "<content_identifier>", // string. ID of the product. Example: "1077218".
			"content_type": "<content_type>", // string. Either product or product_group.
			"content_name": "<content_name>" // string. The name of the page or product. Example: "shirt".
		}
	],
	"value": "<content_value>", // number. Value of the order or items sold. Example: 100.
	"currency": "<content_currency>" // string. The 4217 currency code. Example: "USD".
});

ttq.track('CompletePayment', {
	"contents": [
		{
			"content_id": "<content_identifier>", // string. ID of the product. Example: "1077218".
			"content_type": "<content_type>", // string. Either product or product_group.
			"content_name": "<content_name>" // string. The name of the page or product. Example: "shirt".
		}
	],
	"value": "<content_value>", // number. Value of the order or items sold. Example: 100.
	"currency": "<content_currency>" // string. The 4217 currency code. Example: "USD".
});

ttq.track('Cirurgia Capilar', {
	"contents": [
		{
			"content_id": "<content_identifier>", // string. ID of the product. Example: "1077218".
			"content_type": "<content_type>", // string. Either product or product_group.
			"content_name": "<content_name>", // string. The name of the page or product. Example: "shirt".
			"price": "<content_price>" // number. The price of a single item. Example: 25.
		}
	],
	"value": "<content_value>", // number. Value of the order or items sold. Example: 100.
	"currency": "<content_currency>" // string. The 4217 currency code. Example: "USD".
});
})(window.algoliaShopify);
